export const removeInvalidImages = (icons) => {
  if (!icons || !Array.isArray(icons)) {
    return [] // Return empty array if no icons are present
  }

  return icons.filter(
    (icon) =>
      // Only include icons that have all required properties
      icon && icon.icon && icon.icon.url && icon.icon.width && icon.icon.height,
  )
}

export const mapIconData = (icon) => ({
  url: icon.icon?.url || '',
  width: icon.icon?.width || 0,
  mimeType: icon.icon?.mimeType || '',
  height: icon.icon?.height || 0,
  fluid: {
    src: icon?.icon?.url || '',
    width: icon?.icon?.width || 0,
    height: icon?.icon?.height || 0,
    aspectRatio: icon?.icon?.width && icon.icon.height ? icon.icon.width / icon.icon.height : 1,
    srcSet: '',
    sizes: '',
  },
})
